import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../LanguageProvider";
import Header from "../Reutilizables/Header/Header";
import Footer from "../Reutilizables/Footer/Footer";
import lasVegasButton from "../../assets/button las vegas.png";
import southFloridaButton from "../../assets/whatsapp-south-florida.png";
import lasVegasButtonSpanish from "../../assets/las-vegas-button-transparent.png";
import southFloridaButtonSpanish from "../../assets/south florida spanish.png";
import "./Contact.css";
import emailjs from "@emailjs/browser";

function Contact() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { language } = useLanguage();
  const isSpanish = language === "es";
  const currentLasVegasButton = isSpanish ? lasVegasButtonSpanish : lasVegasButton;
  const currentSouthFloridaButton = isSpanish ? southFloridaButtonSpanish : southFloridaButton;

  const [nombre, setNombre] = useState("");
  const [mail, setMail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [telefonoError, setTelefonoError] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    const phoneRegex = /^[0-9]{10,15}$/;
    if (!phoneRegex.test(telefono)) {
      setTelefonoError(language === "en" ? "Invalid phone number" : "Número de teléfono inválido");
      return;
    }
    setTelefonoError("");
    setIsSubmitting(true);

    try {
      await emailjs.send(
        "language_hero_mailing",
        "template_language_hero",
        { nombre, mail, telefono, mensaje },
        "6Q_8lL9EeO8wjeAjk"
      );
      setMessage(language === "en" ? "Email sent successfully!" : "¡Email enviado con éxito!");
      setNombre("");
      setMail("");
      setTelefono("");
      setMensaje("");
      navigate("/thank-you");
    } catch (error) {
      console.error("Error sending email:", error);
      setMessage(language === "en" ? "Error sending email" : "Error al enviar el email");
      setShowMessage(true);
      setTimeout(() => setShowMessage(false), 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="app-shell contact-page">
      <Header />
      <main className="page-main contact-main">
        <div className="lh-container contact-layout">
          <aside className="contact-sidebar">
            <a href="https://wa.me/17868198806" target="_blank" rel="noopener noreferrer" className="contact-whatsapp-card">
              <img src={currentSouthFloridaButton} alt="South Florida WhatsApp" />
            </a>
            <a href="https://wa.me/17752535836" target="_blank" rel="noopener noreferrer" className="contact-whatsapp-card" aria-label="Las Vegas WhatsApp">
              <img src={currentLasVegasButton} alt="Las Vegas WhatsApp" />
            </a>

            <div className="contact-detail">
              <i className="bi bi-telephone" />
              <div><h2>{t("contactSubTitle1")}</h2><p><b>Miami:</b> +1 (786) 819-8806</p><p><b>Las Vegas:</b> +1 (775) 253-5836</p></div>
            </div>
            <div className="contact-detail">
              <i className="bi bi-envelope" />
              <div><h2>{t("contactSubTitle3")}</h2><p>admin@languageherollc.com</p></div>
            </div>
            <div className="contact-detail">
              <i className="bi bi-clock" />
              <div><h2>{t("contactSubTitle4")}</h2><p>{t("contactSubTitle4a")}</p><p>{t("contactSubTitle4b")}</p></div>
            </div>
          </aside>

          <section className="contact-form-panel">
            <div className="contact-form-panel__content">
              <h1>{language === "en" ? "CONTACT US" : "CONTÁCTANOS"}</h1>
              <span className="contact-title-line" />
              <form onSubmit={handleSubmit} className="contact-form">
                <label htmlFor="nombre">{t("contactTextForm1")}</label>
                <input id="nombre" type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} required />

                <label htmlFor="mail">{t("contactTextForm2")}</label>
                <input id="mail" type="email" value={mail} onChange={(e) => setMail(e.target.value)} required />

                <label htmlFor="telefono">{t("contactTextForm3")}</label>
                <input
                  id="telefono"
                  type="tel"
                  value={telefono}
                  onChange={(e) => setTelefono(e.target.value.replace(/\D/g, ""))}
                  inputMode="numeric"
                  minLength={10}
                  maxLength={15}
                  required
                  className={telefonoError ? "is-invalid" : ""}
                />
                {telefonoError && <small className="contact-form__error">{telefonoError}</small>}

                <label htmlFor="mensaje">{t("contactTextForm4")}</label>
                <textarea id="mensaje" value={mensaje} onChange={(e) => setMensaje(e.target.value)} required />

                <div className="contact-form__actions">
                  <button className="button-primary" type="submit" disabled={isSubmitting}>
                    {t("contactSendBtn")}
                  </button>
                  {showMessage && <span>{message}</span>}
                </div>
              </form>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Contact;
